
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';
import VacancyCardCms from '~/components/vacancies/VacancyCardCms.vue';
import VacancyCardPopup from "~/components/vacancies/VacancyCardPopup.vue";
export default BaseCmsBlock.extend({
  name: 'VacanciesCompanyVacanciesBlock',

  components: {
    VacancyCardCms,
    VacancyCardPopup,
  },

  data() {
    return {
      isShowVacancyPopup: false,
      vacancyForPopup: {},
    }
  },

  computed: {
    localValues: function () {
      return this.externalData?.VacanciesCompanyVacanciesBlock || this.values || {}; // @FIXME ПРОВЕРЬ!
    },
    localExtras: function () {
      return this.extras;
    },
    filteredVacancies: function () {
      return this.localExtras.vacancies?.filter((item) => item.status !== 0);
    },
    allLink: function () {
      return this.values?.link || ""
    },
  },

  methods: {
    openPopup(vacancy) {
      const body = document.querySelector('body')
      body.classList.add('stop-scroll')
      this.isShowVacancyPopup = true
      this.vacancyForPopup = {...vacancy}
    },
    closePopup() {
      const body = document.querySelector('body')
      body.classList.remove('stop-scroll')
      this.isShowVacancyPopup = false
    },
  },
});
